import { faThumbsDown, faThumbsUp, faUser } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import '../assets/css/Common.css'
import '../assets/css/Comment.css'
import { useCallback } from "react"
import { dislikeComment, likeComment, removeLiking } from "../services/CommentService"
import { useModalContext } from "../context/ModalContext"
import { useState } from "react"
import { Button } from "antd"
import UserContext from "../context/UserContext"
import { useContext } from "react"

function Comment({commentId, text, username, likes, dislikes, date, liked, disliked}) {
    const {displayGenericErrorModal} = useModalContext()
    const { userRole } = useContext(UserContext)
    const [nrOfLikes, setNrOfLikes] = useState(likes)
    const [nrOfDislikes, setNrOfDislikes] = useState(dislikes)
    /** Used for css */
    const [userLiked, setUserLiked] = useState(liked)
    const [userDisliked, setUserDisliked] = useState(disliked)

    const handleRemoveLiking = useCallback(() => {
        removeLiking(commentId)
        .then(data => {
            if (userLiked) {
                setUserLiked(false)
                setNrOfLikes(prev => prev - 1)
            } else if (userDisliked) {
                setUserDisliked(false)
                setNrOfDislikes(prev => prev - 1)
            }
        })
        .catch(err => displayGenericErrorModal())
    }, [displayGenericErrorModal, commentId, userLiked, userDisliked, setUserLiked, setUserDisliked, setNrOfDislikes, setNrOfLikes])

    const handleLike = useCallback(() => {
        // If the user already liked the comment, call the handleRemoveLiking method
        if (userLiked) handleRemoveLiking()
        // Otherwise like the comment
        else likeComment(commentId)
            .then(data => {
                setUserLiked(true)
                setNrOfLikes(prev => prev + 1)
                // If the user previously disliked the comment, and now liked it
                if (userDisliked) {
                    setUserDisliked(false)
                    setNrOfDislikes(prev => prev - 1)
                }
            })
            .catch(err => {
                if (err?.response?.status !== 400)
                    displayGenericErrorModal()
            })
    }, [displayGenericErrorModal, commentId, userLiked, userDisliked, setUserDisliked, setUserLiked, setNrOfDislikes, setNrOfLikes, handleRemoveLiking])

    const handleDislike = useCallback(() => {
        // If the user already disliked the comment, call the handleRemoveLiking method
        if (userDisliked) handleRemoveLiking()
        // Otherwise dislike the comment
        else dislikeComment(commentId)
            .then(data => {
                setUserDisliked(true)
                setNrOfDislikes(prev => prev + 1)
                // If the user previously liked the comment, and now disliked it
                if (userLiked) {
                    setUserLiked(false)
                    setNrOfLikes(prev => prev - 1)
                }
            })
            .catch(err => {
                if (err?.response?.status !== 400)
                    displayGenericErrorModal()
            })
    }, [displayGenericErrorModal, commentId, userLiked, userDisliked, setUserDisliked, setUserLiked, setNrOfDislikes, setNrOfLikes, handleRemoveLiking])

    return (
        <div className="flex-container flex-column height-20p padding-1p-no-top comment light-shaddow">
            <div className="flex-container space-between center-align">
                <div className="flex-container space-between center-align">
                    <FontAwesomeIcon icon={faUser} className='text-gray'></FontAwesomeIcon>
                    <i className="left-margin-5p">{username}</i>
                </div>
                <p className="flex-end-item small-text">{date}</p>
            </div>
            
            <div className="whitespace-show line-height-whitespace">
                {text}
            </div>

            <div className="flex-container flex-end-item width-30p center-align end-justify">
                <div className="flex-container margin-2p small-text center-align space-between">
                    <Button onClick={() => handleLike()} disabled={!userRole} className={`${userLiked ? 'comment-liked' : ''}`}>
                        <FontAwesomeIcon icon={faThumbsUp}></FontAwesomeIcon>
                        {nrOfLikes}
                    </Button>
                </div>
                /
                <div className="flex-container margin-2p small-text center-align space-between">
                    <Button onClick={() => handleDislike()} disabled={!userRole} className={`flex-container margin-2p small-text center-align space-between ${userDisliked ? 'comment-disliked' : ''}`}>
                        <FontAwesomeIcon icon={faThumbsDown}></FontAwesomeIcon>
                        {nrOfDislikes}
                    </Button>
                </div>
            </div>
            
        </div>
    )
}

export default Comment